{
  "sourceRefs": [
    "gawronski-kartuizers-2002",
    "gawronski-kartuizers-2001",
    "bakker-sintandries",
    "vandeventer"
  ],
  "note": "A separate charterhouse plan replaces the ordinary 16 m city-convent garth. Gawronski (2002) reports the inner court and cloister at 86 by 90 m, individual houses with lower workshops, upper living rooms and gardens, an eastern chapel/library and a separate forecourt. Twenty-four cells are an inferred arrangement using Bakker’s discussion and Albertinus’s later reconstruction; the study also mentions 22 and no complete 1538 cell plan survives. Cell counts, individual plot divisions, dimensions, heights, openings, materials, garden walls, hall roles, church axis, private access, precinct and moat registration remain estimates. Van Deventer is later; neither the 1538 painting nor the 1544 woodcut includes this compound. Later ruins, taverns, public cemetery, widow courtyard and Jordaan streets are excluded.",
  "chapel": {
    "u": 43,
    "v": 6,
    "angleDeg": 90,
    "u0": -18.5,
    "chordU": 13,
    "vc": 0,
    "half": 5.5,
    "eaveY": 11.5,
    "ridgeY": 19.7
  },
  "belfry": {
    "u": -2,
    "v": 0,
    "radius": 0.45,
    "foot": 18.8,
    "eaves": 20.5,
    "tip": 24
  },
  "cells": [
    {
      "id": "cell-north-01",
      "u": -35,
      "v": 49,
      "angleDeg": 90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-north-02",
      "u": -25,
      "v": 49,
      "angleDeg": 90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-north-03",
      "u": -15,
      "v": 49,
      "angleDeg": 90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-north-04",
      "u": -5,
      "v": 49,
      "angleDeg": 90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-north-05",
      "u": 5,
      "v": 49,
      "angleDeg": 90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-north-06",
      "u": 15,
      "v": 49,
      "angleDeg": 90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-north-07",
      "u": 25,
      "v": 49,
      "angleDeg": 90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-north-08",
      "u": 35,
      "v": 49,
      "angleDeg": 90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-south-01",
      "u": -35,
      "v": -49,
      "angleDeg": -90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-south-02",
      "u": -25,
      "v": -49,
      "angleDeg": -90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-south-03",
      "u": -15,
      "v": -49,
      "angleDeg": -90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-south-04",
      "u": -5,
      "v": -49,
      "angleDeg": -90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-south-05",
      "u": 5,
      "v": -49,
      "angleDeg": -90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-south-06",
      "u": 15,
      "v": -49,
      "angleDeg": -90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-south-07",
      "u": 25,
      "v": -49,
      "angleDeg": -90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-south-08",
      "u": 35,
      "v": -49,
      "angleDeg": -90,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-west-01",
      "u": -47,
      "v": -35,
      "angleDeg": 180,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-west-02",
      "u": -47,
      "v": -25,
      "angleDeg": 180,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-west-03",
      "u": -47,
      "v": -15,
      "angleDeg": 180,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-west-04",
      "u": -47,
      "v": -5,
      "angleDeg": 180,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-west-05",
      "u": -47,
      "v": 5,
      "angleDeg": 180,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-west-06",
      "u": -47,
      "v": 15,
      "angleDeg": 180,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-west-07",
      "u": -47,
      "v": 25,
      "angleDeg": 180,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    },
    {
      "id": "cell-west-08",
      "u": -47,
      "v": 35,
      "angleDeg": 180,
      "length": 8,
      "width": 6.8,
      "eaves": 5.4,
      "ridge": 9,
      "floors": 2,
      "bays": 2,
      "passage": 0,
      "doorSide": 3,
      "blindSides": [0, 2],
      "windowRows": [
        {
          "sill": 0.3,
          "top": 1.3,
          "width": 0.5
        },
        {
          "sill": 2.6,
          "top": 4.0,
          "width": 0.8
        }
      ]
    }
  ],
  "ranges": [
    {
      "id": "library-mary-chapel",
      "u": 55,
      "v": 7,
      "angleDeg": 90,
      "length": 24,
      "width": 7,
      "eaves": 8,
      "ridge": 12.6,
      "floors": 2,
      "bays": 5,
      "passage": 0,
      "doorSide": 0,
      "blindSides": [2]
    },
    {
      "id": "forecourt-north-hall",
      "u": 77,
      "v": 51,
      "angleDeg": 0,
      "length": 44,
      "width": 9,
      "eaves": 7.2,
      "ridge": 12,
      "floors": 2,
      "bays": 8,
      "passage": 0,
      "doorSide": 0
    },
    {
      "id": "forecourt-south-service",
      "u": 78,
      "v": -51,
      "angleDeg": 0,
      "length": 42,
      "width": 8,
      "eaves": 5.4,
      "ridge": 9.4,
      "floors": 1,
      "bays": 7,
      "passage": 0,
      "doorSide": 2
    },
    {
      "id": "entry-gate",
      "u": 106.5,
      "v": 0,
      "angleDeg": 90,
      "length": 17,
      "width": 9,
      "eaves": 7.6,
      "ridge": 13,
      "floors": 2,
      "bays": 4,
      "passage": 3.4
    }
  ],
  "walks": [
    {
      "id": "north",
      "rect": {
        "u0": -43,
        "u1": 43,
        "v0": 42.8,
        "v1": 45
      },
      "front": [
        [-40.8, 42.8],
        [40.8, 42.8]
      ],
      "ridgeAlongU": true,
      "entrance": false
    },
    {
      "id": "south",
      "rect": {
        "u0": -43,
        "u1": 43,
        "v0": -45,
        "v1": -42.8
      },
      "front": [
        [40.8, -42.8],
        [-40.8, -42.8]
      ],
      "ridgeAlongU": true,
      "entrance": false
    },
    {
      "id": "west",
      "rect": {
        "u0": -43,
        "u1": -40.8,
        "v0": -42.8,
        "v1": 42.8
      },
      "front": [
        [-40.8, -42.8],
        [-40.8, 42.8]
      ],
      "ridgeAlongU": false,
      "entrance": false
    },
    {
      "id": "east-south",
      "rect": {
        "u0": 40.8,
        "u1": 43,
        "v0": -42.8,
        "v1": -15.5
      },
      "front": [
        [40.8, -15.5],
        [40.8, -42.8]
      ],
      "ridgeAlongU": false,
      "entrance": true
    },
    {
      "id": "east-north",
      "rect": {
        "u0": 40.8,
        "u1": 43,
        "v0": 33.8,
        "v1": 42.8
      },
      "front": [
        [40.8, 42.8],
        [40.8, 33.8]
      ],
      "ridgeAlongU": false,
      "entrance": false
    }
  ],
  "walls": [
    {
      "from": [-40, 45],
      "to": [-40, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-30, 45],
      "to": [-30, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-20, 45],
      "to": [-20, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-10, 45],
      "to": [-10, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [0, 45],
      "to": [0, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [10, 45],
      "to": [10, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [20, 45],
      "to": [20, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [30, 45],
      "to": [30, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [40, 45],
      "to": [40, 65],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-43, 45],
      "to": [-38.4, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-31.6, 45],
      "to": [-28.4, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-21.6, 45],
      "to": [-18.4, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-11.6, 45],
      "to": [-8.4, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-1.6, 45],
      "to": [1.5999999999999996, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [8.4, 45],
      "to": [11.6, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [18.4, 45],
      "to": [21.6, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [28.4, 45],
      "to": [31.6, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [38.4, 45],
      "to": [43, 45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-40, -65],
      "to": [-40, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-30, -65],
      "to": [-30, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-20, -65],
      "to": [-20, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-10, -65],
      "to": [-10, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [0, -65],
      "to": [0, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [10, -65],
      "to": [10, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [20, -65],
      "to": [20, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [30, -65],
      "to": [30, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [40, -65],
      "to": [40, -45],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-38.4, -45],
      "to": [-43, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-28.4, -45],
      "to": [-31.6, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-18.4, -45],
      "to": [-21.6, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-8.4, -45],
      "to": [-11.6, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [1.5999999999999996, -45],
      "to": [-1.6, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [11.6, -45],
      "to": [8.4, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [21.6, -45],
      "to": [18.4, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [31.6, -45],
      "to": [28.4, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [43, -45],
      "to": [38.4, -45],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-63, -40],
      "to": [-43, -40],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-63, -30],
      "to": [-43, -30],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-63, -20],
      "to": [-43, -20],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-63, -10],
      "to": [-43, -10],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-63, 0],
      "to": [-43, 0],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-63, 10],
      "to": [-43, 10],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-63, 20],
      "to": [-43, 20],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-63, 30],
      "to": [-43, 30],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-63, 40],
      "to": [-43, 40],
      "width": 0.28,
      "height": 1.75
    },
    {
      "from": [-43, -38.4],
      "to": [-43, -43],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-43, -28.4],
      "to": [-43, -31.6],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-43, -18.4],
      "to": [-43, -21.6],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-43, -8.4],
      "to": [-43, -11.6],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-43, 1.5999999999999996],
      "to": [-43, -1.6],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-43, 11.6],
      "to": [-43, 8.4],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-43, 21.6],
      "to": [-43, 18.4],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-43, 31.6],
      "to": [-43, 28.4],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-43, 43],
      "to": [-43, 38.4],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [-64, -66],
      "to": [111, -66],
      "width": 0.5,
      "height": 2.4
    },
    {
      "from": [111, -66],
      "to": [111, -8.5],
      "width": 0.5,
      "height": 2.4
    },
    {
      "from": [111, 8.5],
      "to": [111, 66],
      "width": 0.5,
      "height": 2.4
    },
    {
      "from": [111, 66],
      "to": [-64, 66],
      "width": 0.5,
      "height": 2.4
    },
    {
      "from": [-64, 66],
      "to": [-64, -66],
      "width": 0.5,
      "height": 2.4
    },
    {
      "from": [43, -42.8],
      "to": [43, -30.75],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [43, -27.55],
      "to": [43, -15.5],
      "width": 0.35,
      "height": 3.2
    },
    {
      "from": [43, 33.8],
      "to": [43, 42.8],
      "width": 0.35,
      "height": 3.2
    }
  ],
  "floors": [
    {
      "id": "great-court",
      "ring": [
        [-40.8, -42.8],
        [36.8, -42.8],
        [36.8, 42.8],
        [-40.8, 42.8]
      ],
      "height": 0.025,
      "garden": true
    },
    {
      "id": "forecourt",
      "ring": [
        [64, -46],
        [100, -46],
        [100, 46],
        [64, 46]
      ],
      "height": 0.035,
      "garden": false
    },
    {
      "id": "court-link",
      "ring": [
        [36.8, -30.75],
        [64, -30.75],
        [64, -27.55],
        [36.8, -27.55]
      ],
      "height": 0.05,
      "garden": false
    },
    {
      "id": "garden-north-01",
      "ring": [
        [-39.8, 53],
        [-30.2, 53],
        [-30.2, 65],
        [-39.8, 65]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-north-02",
      "ring": [
        [-29.8, 53],
        [-20.2, 53],
        [-20.2, 65],
        [-29.8, 65]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-north-03",
      "ring": [
        [-19.8, 53],
        [-10.2, 53],
        [-10.2, 65],
        [-19.8, 65]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-north-04",
      "ring": [
        [-9.8, 53],
        [-0.20000000000000018, 53],
        [-0.20000000000000018, 65],
        [-9.8, 65]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-north-05",
      "ring": [
        [0.20000000000000018, 53],
        [9.8, 53],
        [9.8, 65],
        [0.20000000000000018, 65]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-north-06",
      "ring": [
        [10.2, 53],
        [19.8, 53],
        [19.8, 65],
        [10.2, 65]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-north-07",
      "ring": [
        [20.2, 53],
        [29.8, 53],
        [29.8, 65],
        [20.2, 65]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-north-08",
      "ring": [
        [30.2, 53],
        [39.8, 53],
        [39.8, 65],
        [30.2, 65]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-south-01",
      "ring": [
        [-39.8, -65],
        [-30.2, -65],
        [-30.2, -53],
        [-39.8, -53]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-south-02",
      "ring": [
        [-29.8, -65],
        [-20.2, -65],
        [-20.2, -53],
        [-29.8, -53]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-south-03",
      "ring": [
        [-19.8, -65],
        [-10.2, -65],
        [-10.2, -53],
        [-19.8, -53]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-south-04",
      "ring": [
        [-9.8, -65],
        [-0.20000000000000018, -65],
        [-0.20000000000000018, -53],
        [-9.8, -53]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-south-05",
      "ring": [
        [0.20000000000000018, -65],
        [9.8, -65],
        [9.8, -53],
        [0.20000000000000018, -53]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-south-06",
      "ring": [
        [10.2, -65],
        [19.8, -65],
        [19.8, -53],
        [10.2, -53]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-south-07",
      "ring": [
        [20.2, -65],
        [29.8, -65],
        [29.8, -53],
        [20.2, -53]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-south-08",
      "ring": [
        [30.2, -65],
        [39.8, -65],
        [39.8, -53],
        [30.2, -53]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-west-01",
      "ring": [
        [-63, -39.8],
        [-51, -39.8],
        [-51, -30.2],
        [-63, -30.2]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-west-02",
      "ring": [
        [-63, -29.8],
        [-51, -29.8],
        [-51, -20.2],
        [-63, -20.2]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-west-03",
      "ring": [
        [-63, -19.8],
        [-51, -19.8],
        [-51, -10.2],
        [-63, -10.2]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-west-04",
      "ring": [
        [-63, -9.8],
        [-51, -9.8],
        [-51, -0.20000000000000018],
        [-63, -0.20000000000000018]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-west-05",
      "ring": [
        [-63, 0.20000000000000018],
        [-51, 0.20000000000000018],
        [-51, 9.8],
        [-63, 9.8]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-west-06",
      "ring": [
        [-63, 10.2],
        [-51, 10.2],
        [-51, 19.8],
        [-63, 19.8]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-west-07",
      "ring": [
        [-63, 20.2],
        [-51, 20.2],
        [-51, 29.8],
        [-63, 29.8]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "garden-west-08",
      "ring": [
        [-63, 30.2],
        [-51, 30.2],
        [-51, 39.8],
        [-63, 39.8]
      ],
      "height": 0.035,
      "garden": true
    },
    {
      "id": "outer-gate-approach",
      "ring": [
        [111, -1.6],
        [126.4856, -3.7425],
        [126.9353, -0.5743],
        [111, 1.6]
      ],
      "height": 0.05,
      "garden": false
    }
  ]
}
